import * as React from 'react';
import { View } from '../../components/View/View';

const NotFound: React.FC<Props> = (props) => {
    return (
    <View title = "404: Not Found">

    </View>
    )
}

interface Props {

}

export default NotFound;